import { createI18n } from 'vue-i18n';
import { DEFAULT_LOCALE } from '@taxi/shared';
import fr from '@/locales/fr.json';
import en from '@/locales/en.json';
import it from '@/locales/it.json';

const STORAGE_KEY = 'taxi_locale';

/**
 * Langue de l'interface.
 *
 * La clientèle de Monaco est très majoritairement étrangère : le sélecteur est
 * visible en permanence sur la borne, et le choix est mémorisé. À défaut, on
 * suit la langue du navigateur si elle fait partie des langues servies.
 */
function detectLocale(): string {
	const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
	if (stored && ['fr', 'en', 'it'].includes(stored)) {
		return stored;
	}
	const browser = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : '';
	return ['fr', 'en', 'it'].includes(browser) ? browser : DEFAULT_LOCALE;
}

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: detectLocale(),
	fallbackLocale: DEFAULT_LOCALE,
	messages: { fr, en, it },
});

export function setLocale(locale: string): void {
	(i18n.global.locale as unknown as { value: string }).value = locale;
	window.localStorage.setItem(STORAGE_KEY, locale);
	document.documentElement.setAttribute('lang', locale);
}

export default i18n;
